import { render, staticRenderFns } from "./lp.vue?vue&type=template&id=fa430cfe&"
import script from "./lp.vue?vue&type=script&lang=js&"
export * from "./lp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports